module.exports = __webpack_public_path__ + "img/arrow-angle-pointing-to-right.ef26effe.svg";